import Headcom from "../../src/components/Headcom";
import FooterCom from "../../src/components/FooterCom";
import FooterDis from "../../src/Description/FooterDis";
import CookieCom from "../../src/components/CookieCom";
import { Assets } from "../../src/list/Assets";
import { supabase } from "../../lib/supabaseClient";
import { useRouter } from "next/router";
import { useEffect } from "react";
import Link from "next/link";
import Snow_fx from "../../src/fx/Snow_fx";

export default function PrivacyPage({ pageData }) {
  const path = useRouter();

  useEffect(() => {
  }, []);
  return (
    <div>
      <Headcom
        title={pageData?.title || 'Privacy Policy'}
        s_dis={pageData?.s_dis || ''}
        path={pageData?.path ? pageData.path[1] + pageData.path[0] : ''}
        thumb={pageData?.thumb || ''}
        logo_16={Assets[0].logo_16}
        logo_32={Assets[0].logo_32}
        logo_192={Assets[0].logo_192}
        logo_270={Assets[0].logo_270}
        logo_512={Assets[0].logo_512}
      />
<div className="privacy-form">
        <div className="privacy-container">
          {/* <Link href={"/"}>
            <a className="privacy-logo" >
                <img decoding="async" alt="Logo" title="logo" src={Assets[0].logo2} ></img>
            </a>
            </Link> */}
            {pageData?.dis ? (
              <div dangerouslySetInnerHTML={{ __html: pageData.dis }} />
            ) : (
              <>
                <h1>Privacy Policy</h1>
            <p>BestGameSpot is committed to providing a safe and fun website for children of all ages. The privacy policy is intended to let you know how BestGameSpot protects your personal information. By accessing BestGameSpot, you acknowledge and fully understand BestGameSpot. Privacy Policy and freely consent to the information collection and use practices described in this Privacy Policy.</p>
            <h2>Third Party Policies</h2>
            <p>Websites visited through links from this website may or may not have their own privacy statements and BestGameSpot is not responsible for the privacy practices or contents of those sites.</p>
            <h2>What Information Is Collected?</h2>

            <p>BestGameSpot implemented the following Google Analytics features based on Display Advertising: Google Analytics Demographics and Interest Reporting.</p>
            <p>You can opt-out of Google Analytics for Display Advertising and customize Google Display Network ads using the Ads Settings.</p>
            <p>We do not collect any personal information from our visitors. Visitors are required to be 13 years or older to play the games on BestGameSpot. If not they must be accompanied by a parent or guardian who is directly supervising them. If you are not 13 years of age, have your parents review these Terms of Use. When visitors come to our site, we automatically collect some non-personally identifiable “computer” information, such :</p>


            <li>Your Internet protocol address.</li>
            <li>The kind of browser or computer you use.</li>
            <li>Number of links you click within the site.</li>
            <li>State or country from which you accessed the site.</li>
            <li>Date and time of your visit.</li>
            <li>Name of your Internet service provider.</li>
            <li>Referring website.</li>
            <li>Pages you viewed on the site.</li>
            <h2>Copyright</h2>
            <p>All the games published on this portal together with the Intellectual Property belong to their respective owners. If any games published break any ownership rights, please contact us right away and we’ll make sure to remove the games in the shortest time possible.</p>
            <h2>How We Use the Information</h2>
            <p>We use visitors computer information to track usage, improve the design of the site, offer products and services, to personalize our visitor’s experiences, save visitor’s password in password-protected areas, and to ensure visitors are following the site’s Agreement.</p>
            <p>We may disclose information about our visitors, including personal information (e.g., registration information, e-mail address, the content of messages), as well as computer information, when legally required to do so, at the request of governmental authorities conducting an investigation, to verify or enforce compliance with the policies governing our Site and applicable laws, or to protect against misuse or unauthorized use of the site. We also may disclose user information whenever we believe disclosure is necessary to limit our legal liability; to protect or defend our rights or property; or protect the safety, rights, or property of our visitors or others.</p>
            <h2>Cookies</h2>
            <p>Cookies are small text files that we place in visitor’s computer browsers to store their preferences. Cookies cannot damage user files, nor can they read information from a user’s hard drive. Cookies allow web sites to “remember” users activities on a web site as well as users visits to a site. We do not store any personal information into cookies or link cookies to any personal information that players submit online when participating in our activities. You can, of course, disable cookies on your computer by indicating this in the preferences; however, some of the functioning of features on the web site may be affected.</p>
            <h2>Security</h2>
            <p>To prevent unauthorized access, maintain data accuracy, and ensure the correct use of information, we have put in place appropriate physical, electronic, and managerial procedures to safeguard and secure the information we collect online. The security and confidentiality of your information are extremely important to us. We have implemented technical, administrative, and physical security measures to protect information from unauthorized access and improper use. From time to time, we review our security procedures in order to consider appropriate new technology and methods. Please be aware though that, despite our best efforts, no security measures are perfect or impenetrable.</p>
            <h2>Changes to this Privacy Policy</h2>
            <p>BestGameSpot reserves the right to change this policy at any time. We ask that you review this Privacy Policy from time to time to ensure you are familiar with the most current version of it.</p>
              </>
            )}
        </div>
        
    </div>
    
    {/* <FooterDis/> */}
    <FooterCom/>
    <CookieCom/>
    <Snow_fx/>
    </div>
  );
}

export async function getStaticProps() {
  const { data: pages } = await supabase
    .from('pages')
    .select('*')
    .eq('name', 'Privacy')
    .single();

  return {
    props: {
      pageData: pages || null
    },
    revalidate: 60
  };
}
